exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ml-15[data-v-10a12c81]{margin-left:15px}.fl-r[data-v-10a12c81]{float:right}.mt-20[data-v-10a12c81]{margin-top:20px}.mr-20[data-v-10a12c81]{margin-right:20px}#print[data-v-10a12c81]{display:none}.tableColumns[data-v-10a12c81]{height:auto;float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-10a12c81","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pharmacy/check/index.vue
// module id = YSS8
// module chunks = 67 239